import React from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, IconButton
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ArticleIcon from "@mui/icons-material/Article";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAuth } from "../../../context/AuthContext";

const SociosTable = ({ socios, onEdit, onVerRegistros, onVerPagos, onDelete }) => {
const { rol: userRole } = useAuth();

  //console.log(userRole)

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID Socio</TableCell>
            <TableCell>Nombre</TableCell>
            <TableCell>País</TableCell>
            <TableCell>Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {socios.map((socio) => (
            <TableRow key={socio.ID_SOCIO}>
              <TableCell>{socio.ID_SOCIO}</TableCell>
              <TableCell>{socio.NOMBRE_APELLIDO}</TableCell>
              <TableCell>{socio.PAIS}</TableCell>
              <TableCell>
                {(userRole === "admin" || userRole === "gestor") && (
                  <IconButton onClick={() => onEdit(socio)} title="Editar">
                    <EditIcon />
                  </IconButton>
                )}
                {(userRole === "admin" || userRole === "gestor") && (
                  <IconButton onClick={() => onVerRegistros(socio)} title="Ver registros">
                    <ArticleIcon />
                  </IconButton>
                )}
                {(userRole === "admin" || userRole === "cobranzas" || userRole === "gestor") && (
                  <IconButton onClick={() => onVerPagos(socio)} title="Ver pagos">
                    <MonetizationOnIcon />
                  </IconButton>
                )}
                {userRole === "admin" && (
                  <IconButton onClick={() => onDelete(socio)} title="Eliminar">
                    <DeleteIcon />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SociosTable;